
import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-list-toolbar-sort-select',
})
export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;

  readonly sortOptions: Array<object> = [
    {
      name: this.$t('sort-price-desc'),
      sorting: {price: 'desc'},
    },
    {
      name: this.$t('sort-price-asc'),
      sorting: {price: 'asc'},
    },
    {
      name: this.$t('sort-recommended'),
      sorting: {popularity_index_i: 'desc'},
    },
    {
      name: this.$t('sort-name-asc'),
      sorting: {name_s: 'asc'},
    },
    {
      name: this.$t('sort-name-desc'),
      sorting: {name_s: 'desc'},
    },
  ];

  private get currentSorting(): object {
    return typeof this.$store.getters[`${this.dataSource}/currentSort`] !== 'undefined' ? this.$store.getters[`${this.dataSource}/currentSort`] : {};
  }

  private updatePage(sorting): void {
    this.$store.dispatch(`${this.dataSource}/updatePageSort`, JSON.parse(sorting.target.value));
  }

  private checkSelected(selection): boolean {
    return JSON.stringify(this.currentSorting) === JSON.stringify(selection);
  }
}
